export const getConfirmationOptions = (t) => [
	{ value: 'suspect', label: t('admin.animal.confirmation_suspect') },
	{ value: 'confirmed', label: t('admin.animal.confirmation_confirmed') }
]